import { Modal, Radio, Icon, Tooltip } from 'antd';
import * as React from 'react';
import injectSheet from 'react-jss';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter } from '../../../../actions/inquiryShipperActionsBids';
import { connect } from 'react-redux';
import { InquiryModes } from 'src/Library/Constants';

const styles = (theme) => ({
  modal: {
    position: 'absolute',
    marginTop: '1%',
    '& .ant-modal-body': {
      padding: '12px',
    },
  },
});
class ShipperBidsSortByModal extends React.Component<any, any> {
  onChange = (e) => {
    this.props.setFilter({
      sortBy: e.target.value,
      descendingOrder: false,
    });
    this.props.handleCancel();
    this.props.applyFilter(this.props.id);
  };

  handleOrder = (val) => {
    val === 'asc'
      ? this.props.setFilter({ descendingOrder: false })
      : this.props.setFilter({ descendingOrder: true });
    this.props.handleCancel();
    this.props.applyFilter(this.props.id);
  };

  renderOrderIcons() {
    const { appliedFilters, filters } = this.props;
    return (
      <div style={{ display: 'flex', width: '20px', justifyContent: 'space-between' }}>
        <Tooltip placement="top" title="Ascending Order">
          <Icon
            type="caret-up"
            onClick={
              appliedFilters.descendingOrder === true ? () => this.handleOrder('asc') : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${appliedFilters.descendingOrder === true ? '#505050a6' : '#000000'}`,
            }}
          />
        </Tooltip>
        <Tooltip placement="top" title="Descending Order">
          <Icon
            type="caret-down"
            onClick={
              appliedFilters.descendingOrder === false ? () => this.handleOrder('desc') : undefined
            }
            style={{
              float: 'left',
              marginTop: '5px',
              height: '8px',
              width: '8px',
              color: `${appliedFilters.descendingOrder === true ? '#000000' : '#505050a6'}`,
            }}
          />
        </Tooltip>
      </div>
    );
  }

  render() {
    const { classes, visible, handleCancel, compareBidModal, mode } = this.props;
    const option = [
      ['total_charge', 'Total Charge'],
      ['transit_time', 'Transit Time'],
      ['updated_at', 'Updated At'],
    ];
    if ([InquiryModes.TRAILER].includes(mode)) {
      option.unshift(['round_trip_time_hours', 'Round Trip Time']);
    } else {
      option.unshift(['rank', 'Rank']);
    }
    return (
      <div>
        <Modal
          className={classes.modal}
          visible={visible}
          onCancel={handleCancel}
          closable={false}
          footer=""
          mask={false}
          width="13%"
          style={{
            marginLeft: compareBidModal ? '25%' : '53%',
            top: compareBidModal ? '42px' : undefined,
          }}
        >
          <Radio.Group
            value={this.props.appliedFilters.sortBy}
            onChange={this.onChange}
            style={{ width: '100%' }}
            defaultValue={option?.[0]?.[0] || 'rank'}
          >
            {option.map((item) => {
              return (
                <div
                  key={item[0]}
                  style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}
                >
                  <div>
                    <Radio value={item[0]}>{item[1]}</Radio>
                  </div>
                  {this.props.appliedFilters.sortBy === item[0] ? this.renderOrderIcons() : null}
                </div>
              );
            })}
          </Radio.Group>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ inquiryShipperBidsReducer }) => ({
  filters: inquiryShipperBidsReducer.selectedFilters,
  appliedFilters: inquiryShipperBidsReducer.appliedFilters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
      applyFilter,
    },
    dispatch
  );
export default injectSheet(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ShipperBidsSortByModal)
);
